export default __webpack_public_path__ + "static/william-3aa9754d6e182cfd434612a6ac825e40.png";